import React, { useMemo } from 'react';

import { ReportDatasetDefinition } from '../../ReportDatasetDefinition';
import { getReportDatasetDefinitions } from '../../../store';
import { useAppSelector } from '../../../../../../hooks/react-redux';

interface ReportDatasetFieldProps {
    childDatasetId: string;
    fieldOpen: boolean;
    parents: number;
    fieldHidden: boolean;
    parentHiddenDocumentNameIds?: number[];
    id: string;
}

export const ReportDatasetField: React.FC<ReportDatasetFieldProps> = ({
    childDatasetId,
    fieldOpen,
    parents,
    fieldHidden,
    parentHiddenDocumentNameIds,
    id
}) => {
    const datasetDefinitions = useAppSelector(getReportDatasetDefinitions);
    const datasetDefinition = useMemo(() => datasetDefinitions.find(({ datasetId }) => (datasetId === parseInt(childDatasetId) || null)), [datasetDefinitions, childDatasetId]);

    return (
        <div data-testid={`report-dataset-definition-wrapper-${childDatasetId}`}>
            {fieldOpen && datasetDefinition && <ReportDatasetDefinition datasetDefinition={datasetDefinition} parents={parents + 1} datasetHidden={fieldHidden} parentHiddenDocumentNameIds={parentHiddenDocumentNameIds} parentFieldId={id} />}
        </div>
    );
};
